import { useMemo, useState } from "react";
import { Container, Button, InputGroup, Input } from "reactstrap";
import { useQuery } from "react-query";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AddMeetings from "./AddAttendance";
import {
  deleteClickHandler,
  extractMeetingData,
  extractMeetingMemberData,
  modalHandler,
  onEditClickHandler,
  setCurrentPageMeeting,
} from "./AddAttendance/AddAttendanceMethods/AddAttendanceModalMethods";
import { handleAdminMeetingSearch } from "./AttendanceMethods";
import {
  getAttendanceDetails,
  getMeetingDetails,
} from "../../../../Api/AdminApis";
import CardsWithTable from "../../../../Components/Containers/CardsWithTable";
import ModalContainer from "../../../../Components/Containers/ModalContainer/ModalContainer";
import AddAttendance from "./AddAttendance";
import { usePermission } from "../../../../Components/Permissions/Admin/AdminPermission";

const AttendanceIndex = () => {
  const { currentPage = "1" } = useParams();
  const navigate = useNavigate();
  const { pathname } = useLocation()
  const { checkPermission } = usePermission();
  const [isOpen, setIsOpen] = useState(false); // Add doctor modal
  const [modalEditData, setModalEditData] = useState<any>([]); // data for edit modal
  const [searchQuery, setSearchQuery] = useState<string>("");

  const {
    data: attendance,
    error: attendanceError,
    isLoading: attendanceLoading,
    refetch: attendanceListRefetch,
  }: any = useQuery(
    [`attendance${currentPage + searchQuery}`, currentPage, searchQuery],
    () => getAttendanceDetails(currentPage, searchQuery),
    { keepPreviousData: true }
  );

  const {
    data: meeting,
    error: meetingError,
    isLoading: meetingLoading,
    refetch: meetingListRefetch,
  }: any = useQuery(
    [`meeting${currentPage + searchQuery}`, currentPage, searchQuery],
    () => getMeetingDetails(currentPage, searchQuery),
    { keepPreviousData: true }
  );

  const attendanceData = useMemo(
    () => extractMeetingMemberData(attendance),
    [attendance]
  );
  const meetingData = useMemo(() => extractMeetingData(meeting), [meeting]);

  return (
    <section>
      <div className="content-outer-wrap">
        <Container>
          <div className="search-bar-full-wrap">
            <div className="search-bar">
              <InputGroup>
                <Input
                  placeholder="Search here..."
                  onChange={(e) =>
                    handleAdminMeetingSearch(e, setSearchQuery, navigate)
                  }
                />
                <span className="icon-container">
                  <i className="icon xl icon-search"></i>
                </span>
              </InputGroup>
            </div>
            <div className="right-side-wrap">
              <div className="filter-wrap">
                <div className="button-wrap">
                  {checkPermission("meetings:write") ? <Button
                    onClick={() => modalHandler(setModalEditData, setIsOpen)}
                    color="primary"
                    className="sm"
                  >
                    <i className="icon icon-add-new xl"></i>Attendance
                  </Button> : null}
                </div>
              </div>
            </div>
          </div>
          {/* cards section */}
          <div className="content-list-outer-wrap">
            <CardsWithTable
              data={attendanceData}
              tableTitle="Attendance Details"
              tableFields={["Meeting Name"]}
              Arraykeys={["title"]}
              viewType="table"
              toURL={""}
              // actions={["edit", "delete"]}
              actions={[
                checkPermission("meetings:write") ? "edit" : "",
                checkPermission("meetings:delete") ? "delete" : "",
              ]}
              isLoading={meetingLoading}
              error={meetingError}
              onEditClick={(selectedId: any) => {
                if (checkPermission("meetings:write")) {
                  onEditClickHandler(
                    selectedId,
                    setModalEditData,
                    setIsOpen,
                    attendance
                  )  
                }
              }
              }
              onDeleteClick={(selectedId: string | number) =>
                deleteClickHandler(selectedId, meetingListRefetch)
              }
              paginationData={meeting?.meta}
              setCurrentPage={(pageNo: string) =>
                setCurrentPageMeeting(navigate, pageNo, pathname)
              }
              from_attendance={true}
            />
          </div>
        </Container>
      </div>

      <ModalContainer
        isOpen={isOpen}
        setIsopen={setIsOpen}
        title={
          modalEditData?.length !== 0 ? "Edit Attendance" : "Add Attendance"
        }
      >
        <AddAttendance
          setIsOpen={setIsOpen}
          modalEditData={modalEditData}
          refetch={meetingListRefetch}
          meeting={meetingData}
        />
      </ModalContainer>
    </section>
  );
};

export default AttendanceIndex;
